import React from 'react'

import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { setSimulationReady } from 'Pods/SearchPage/Store/actions/simulationReady'
import {
  setMultipleParts, setPreSupported, setThreeDPrintVerified, setWithMakes,
} from 'Pods/SearchPage/Store/actions/threeDPrintOnly'

import PrintAttributesChip from './PrintAttributesChip'

const CHIPS = [
  { key: 'with_makes', select: state => state.withMakes, onChange: setWithMakes },
  { key: 'three_d_print_verified', select: state => state.threeDPrintVerified, onChange: setThreeDPrintVerified },
  { key: 'pre_supported', select: state => state.preSupported, onChange: setPreSupported },
  {
    key: 'multiple_parts',
    select: state => state.multipleParts,
    onChange: setMultipleParts,
    // 640-959 the row only fits three checkboxes next to Sort and the search.
    isHiddenAtSm: true,
  },
  {
    key: 'simulation_ready',
    select: state => state.simulationReady,
    onChange: setSimulationReady,
    isHiddenAtMd: true,
  },
]

function PrintAttributes() {
  const translate = useTranslate()

  return (
    <div
      className="print-attributes"
      role="group"
      aria-label={translate('search_page.filters.print_attributes.group_label')}
    >
      {CHIPS.map(({
        key, select, onChange, isHiddenAtMd, isHiddenAtSm,
      }) => (
        <PrintAttributesChip
          key={key}
          chipKey={key}
          select={select}
          onChange={onChange}
          isHiddenAtMd={isHiddenAtMd}
          isHiddenAtSm={isHiddenAtSm}
        />
      ))}
    </div>
  )
}

export default PrintAttributes
